import {
  CREATE_PRACTICE,
  CREATE_PRACTICE_SUCCESS,
  CREATE_PRACTICE_FAILURE,
} from 'store/createPractice/createPracticeAction';

const initialState = {
  loading: false,
  users: [],
  error: '',
};

const createPracticeReducer = (state = initialState, action) => {
  switch (action.type) {
    case CREATE_PRACTICE:
      return { ...state, loading: true };
    case CREATE_PRACTICE_SUCCESS:
      return { ...state, loading: false, users: action.payload, error: '' };
    case CREATE_PRACTICE_FAILURE:
      return { ...state, loading: false, users: [], error: action.payload };
    default:
      return state;
  }
};

export default createPracticeReducer;
